import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { tableGamesRouteI18n } from '../i18n/table-games-route-i18n';

export function tableGamesRoutePath(config?: TranslationConfig): string {
  return `${langRoutePath(config)}/${tableGamesRouteI18n(config)}`;
}
